import PropTypes from 'prop-types';
import React, { memo, useContext } from 'react';
import { connect } from 'react-redux';
import { AppContext } from '@prisjakt/ui-app-context';
import Tag from '@prisjakt/ui-tag';

const getTag = (item, onChange, isClearTag) => (
  <Tag
    key={item.name}
    onClick={onChange}
    value={item.name}
    type={isClearTag ? 'clear' : 'default'}
  />
);

const TagCloud = ({ selected, selectionsCount, onChange, onClear }) => {
  const { t } = useContext(AppContext);
  return (
    <div>
      {selectionsCount > 0 &&
        selected.map(item =>
          getTag(item, () =>
            onChange({
              id: item.type,
              value: item.id,
              isGrouped: item.isGrouped,
            })
          )
        )}

      {selectionsCount > 1 &&
        getTag(
          {
            id: '0',
            type: 'clear',
            name: t('campaigns', 'filter.clear-button'),
          },
          onClear,
          true
        )}
    </div>
  );
};

const { shape, arrayOf, string, func, number, bool } = PropTypes;

TagCloud.propTypes = {
  selectionsCount: number.isRequired,
  selected: arrayOf(
    shape({
      id: string.isRequired,
      name: string.isRequired,
      isGrouped: bool.isRequired,
    })
  ).isRequired,
  onChange: func.isRequired,
  onClear: func.isRequired,
};

export default connect(state => state.areas.campaign)(memo(TagCloud));
